import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import ProfileAvatarTwo from "../Assets/ProfileAvatarTwo.png";
import CloseIcon from "../Assets/Icons/closeIcon.svg";
import UploadIcon from "../Assets/Icons/uploadIcon.svg";
import DatePicker from "./DatePicker";
import PlusIcon from "../Assets/Icons/plusWhite.svg";
import AiTeamDropDown from "./AiTeamDropDown";
import InfoIcon from "../Assets/Icons/infoIcon.svg";
import AvatarDropdown from "./AvatarDropdown";

export default function SaveProject({ open, setOpen }) {
  const cancelButtonRef = useRef(null);
  return (
    <Transition.Root show={open} onClose={setOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform  rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-[42rem] sm:max-w-lg">
                <div className="bg-white px-5 pb-4 pt-4 sm:p-3 sm:pb-4 sm:px-5">
                  <div className="sm:flex sm:items-center sm:flex-col">
                    <div className="flex items-center flex-col justify-center gap-6">
                      <h1 className="text-[1.2rem] font-[600] text-[#111928] text-center">
                        SUCCESS! You Project Has Been Saved.
                      </h1>
                      <button className="w-[12rem] h-[2.2rem] text-[0.95rem] text-white font-[500] rounded-[8px] bg-[#942A27]">
                        VIEW ALL AI PROJECTS
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
